import {
  MdHistory,
  MdMenuBook,
  MdOutlineAttachMoney,
  MdOutlineShowChart,
  MdWork,
  MdEvent,
  MdAccessTime,
  MdSettings,
  MdRocketLaunch,
  MdOndemandVideo,
  MdDescription,
} from 'react-icons/md';
import { IoCart, IoBriefcase } from 'react-icons/io5';
import { GrCatalog, GrUserWorker } from 'react-icons/gr';
import { FaHelmetSafety } from 'react-icons/fa6';
import {
  FaCar,
  FaClipboardCheck,
  FaFileInvoice,
  FaHandshake,
  FaListAlt,
  FaShieldAlt,
  FaToolbox,
  FaUser,
  FaUserCheck,
  FaUsers,
} from 'react-icons/fa';
import { AiFillTool } from 'react-icons/ai';

import { ISidebarItem } from '../interfaces/i-sidebar-item';

export const sidebar: ISidebarItem[] = [
  {
    key: 'logs-de-auditoria',
    label: 'Auditoria',
    icon: MdHistory,
  },
  {
    key: 'configuracoes',
    label: 'Configurações',
    icon: MdSettings,
  },
  {
    key: 'st',
    label: 'ST',
    icon: FaHelmetSafety,
    href: '/st',
  },
  {
    key: 'importacoes',
    label: 'Onboarding',
    icon: MdRocketLaunch,
    href: '/importacoes',
  },
  {
    key: 'estatisticas',
    label: 'Estatísticas',
    icon: MdOutlineShowChart,
  },
  {
    key: 'treinamentos',
    label: 'Treinamentos',
    icon: MdOndemandVideo,
    href: '/treinamentos',
  },
  {
    key: 'perfis',
    label: 'Perfis',
    icon: FaUsers,
  },
  {
    key: 'usuarios',
    label: 'Usuários',
    icon: FaUser,
  },
  {
    key: 'rh',
    label: 'RH',
    icon: GrCatalog,
    children: [
      {
        key: 'funcionarios',
        label: 'Funcionários',
        icon: GrUserWorker,
      },
      {
        key: 'avaliacoes',
        label: 'Avaliações',
        icon: FaClipboardCheck,
        href: '/rh/avaliacoes',
      },
      {
        key: 'folha-salarial',
        label: 'Folha salárial',
        icon: MdOutlineAttachMoney,
      },
      {
        key: 'feriados',
        label: 'Feriados',
        icon: MdEvent,
      },
      {
        key: 'cartao-de-ponto',
        label: 'Cartão de Ponto',
        icon: MdAccessTime,
        href: '/employees/clockin',
      },
      {
        key: 'atestados',
        label: 'Documentos',
        icon: MdDescription,
        href: '/rh/documentos',
      },
      {
        key: 'despesas-obra',
        label: 'Despesas',
        icon: MdOutlineAttachMoney,
        href: '/rh/despesas',
      },
    ],
  },
  {
    key: 'despesas',
    label: 'Despesas',
    icon: MdOutlineAttachMoney,
    children: [
      {
        key: 'cadastros',
        label: 'Cadastros',
        icon: MdMenuBook,
      },
      {
        key: 'pedidos',
        label: 'Pedidos',
        icon: IoCart,
      },
      {
        key: 'notas-fiscais',
        label: 'Notas Fiscais',
        icon: FaFileInvoice,
      },
      {
        key: 'fornecedores',
        label: 'Fornecedores',
        icon: FaHandshake,
        href: '/fornecedores',
      },
    ],
  },
  {
    key: 'veiculos',
    label: 'Veículos',
    icon: FaCar,
    children: [
      {
        key: 'cadastros',
        label: 'Cadastros',
        icon: MdMenuBook,
      },
      {
        key: 'vinculos',
        label: 'Vínculos',
        icon: FaUserCheck,
      },
      {
        key: 'usos',
        label: 'Usos',
        icon: FaListAlt,
      },
    ],
  },
  {
    key: 'comercial',
    label: 'Comercial',
    icon: IoBriefcase,
    children: [
      {
        key: 'propostas',
        label: 'Projetos',
        icon: MdWork,
        href: '/propostas',
      },
      {
        key: 'patrimonio',
        label: 'Patrimônio',
        icon: AiFillTool,
        href: '/patrimonio',
      },
      {
        key: 'ferramentas',
        label: 'Ferramentas',
        icon: FaToolbox,
        href: '/ferramentas',
      },
      {
        key: 'arts',
        label: 'ARTs',
        icon: FaShieldAlt,
        href: '/arts',
      },
      {
        key: 'aprs',
        label: 'APRs',
        icon: FaClipboardCheck,
        href: '/aprs',
      },
      {
        key: 'cronogramas',
        label: 'Cronogramas',
        icon: MdEvent,
        href: '/cronogramas',
      },
      {
        key: 'clientes',
        label: 'Clientes',
        icon: FaUserCheck,
        href: '/clientes',
      },
    ],
  },
];

// Rotas que devem usar o layout privado (Header + Sidebar) mas NÃO aparecem
// como item de menu. A tela de notificações é acessada pelo sino do Header;
// as telas de medição são acessadas pela aba de medições da obra.
const extraPrivateRouteKeys = ['notificacoes', 'medicoes'];

export const sidebarRouteKeys = [
  ...sidebar.flatMap((item) => {
    const keys = [item.key];
    if (item.href) keys.push(item.href.replace(/^\//, ''));
    (item.children || []).forEach((child) => {
      keys.push(child.key);
      if (child.href) keys.push(child.href.replace(/^\//, ''));
    });
    return keys;
  }),
  ...extraPrivateRouteKeys,
];
